import axios from 'axios';
import { buildRevJetBanner, buildRevJetBannerMock } from './revjet';
import { getQueryParams, getApiUrl } from './requestUrlHelpers';
import {
  getUrlParams,
  getMockPlaData,
  isBrandFpn,
  haveProductsChanged
} from './helpers';

export const shouldMakeApiRequest = ({ lastRequestScenario, experienceContext, pageContext }) => {
  if (isBrandFpn({ experienceContext, pageContext })) {
    return false;
  }

  const currentUrl = window.location.pathname + window.location.search;
  if (lastRequestScenario.url !== currentUrl) {
    if (pageContext.isCategory || pageContext.isPip) {
      return true;
    }

    if (haveProductsChanged({ lastRequestScenario, pageContext })) {
      return true;
    }
  }

  return false;
};

export const makeApiRequest = (requestConfig) => {
  const params = getUrlParams(window.location.href);

  if (params.mockSponsoredBannerId) {
    requestConfig.setHasData(true);
    buildRevJetBannerMock(requestConfig);
  } else if (params.mockPlaSku) {
    requestConfig.setAdProducts(getMockPlaData(params.mockPlaSku));
  } else {
    const queryParams = getQueryParams(requestConfig);
    const apiUrl = getApiUrl(queryParams);

    axios.get(apiUrl).then((response) => {
      const { data } = response;
      if (data) {
        if (requestConfig.carouselType) {
          requestConfig.setAdProducts(data.products);
          if (requestConfig.setPageId) {
            requestConfig.setPageId(data.pageId);
          }
        } else {
          requestConfig.setHasData(true);
          buildRevJetBanner({ data, requestConfig });
        }
      }
    }).catch((error) => {
      console.log('ERROR: Could not make api request', error);
    });
  }
};
